module.exports = __webpack_public_path__ + "static/media/pasta.34f8f50f.jpg";